import * as yup from 'yup'

export const validationSchema = yup.object({
  email: yup
    .string()
    .email('Insira um e-mail válido')
    .required('E-mail é obrigatório'),
  password: yup
    .string()
    .required('Senha é obrigatório')
    .min(8, 'Senha deve ter no mínimo 8 caracteres'),
})
